import { useLayoutEffect, useEffect } from 'react'

const TAILWIND_2XL_QUERY = '(min-width: 1536px)'
const DAY_WIDTH_SCALE_2XL = 1.0
const DAY_WIDTH_SCALE = 0.7

const GetTrainingTimelineItemWidthModifier = () => {
    if (typeof window !== 'undefined' && window.matchMedia(TAILWIND_2XL_QUERY).matches) {
        return DAY_WIDTH_SCALE_2XL
    }
    
    return DAY_WIDTH_SCALE
}

export default function TrainingTimelineViewport({ 
    viewportRef,
    setViewportWidth = () => {},
    setTrainingTimelineItemWidthModifier = () => {},
    children
}) {

    const DisablePageSwipeNavigation = () => {
        document.documentElement.style.overscrollBehaviorX = 'none'
        document.body.style.overscrollBehaviorX = 'none'
    }

    const RestorePageSwipeNavigation = () => {
        document.documentElement.style.overscrollBehaviorX = ''
        document.body.style.overscrollBehaviorX = ''
    }

    // Set viewport width on mount and when window size changes

    useLayoutEffect(() => {
        const UpdateViewportWidth = () => {
            setViewportWidth(viewportRef.current.clientWidth)
        }

        UpdateViewportWidth()

        const resizeObserver = new ResizeObserver(UpdateViewportWidth)

        resizeObserver.observe(viewportRef.current)

        return () => {
            resizeObserver.disconnect()
        }
    }, [])

    // Set training timeline item width modifier on mount and when window size changes

    useEffect(() => {
        const UpdateTrainingTimelineItemWidthModifier = () => {
            const newTrainingTimelineItemWidthModifier = GetTrainingTimelineItemWidthModifier()
            setTrainingTimelineItemWidthModifier(newTrainingTimelineItemWidthModifier)
            // console.log('Updated training timeline item width modifier to', newTrainingTimelineItemWidthModifier)
        }

        UpdateTrainingTimelineItemWidthModifier()

        const mediaQuery = window.matchMedia(TAILWIND_2XL_QUERY)

        mediaQuery.addEventListener('change', UpdateTrainingTimelineItemWidthModifier)

        return () => {
            mediaQuery.removeEventListener('change', UpdateTrainingTimelineItemWidthModifier)
        }
    }, [])

    // macOS trackpads navigate back / forward on a horizontal two finger swipe. The browser decides that when the gesture starts, from the
    // page's overscroll behavior, so it is turned off for horizontal overscroll while the cursor is over the timeline (and restored after)

    useEffect(() => RestorePageSwipeNavigation, []) // Restore if the timeline unmounts while hovered

    return (
        <div 
            className="relative w-full overflow-hidden select-none cursor-ew-resize overscroll-x-none"
            ref={viewportRef}
            onMouseEnter={DisablePageSwipeNavigation}
            onMouseLeave={RestorePageSwipeNavigation}
        >
            {children}
        </div>
    )
}